export default "__VITE_ASSET__BjImZ2RX__"